import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
    Box,
    Container,
    Typography,
    TextField,
    Button,
    CircularProgress
} from '@mui/material';
import axios from 'axios';

const brandGreen = '#12c099';

const UpdatePhonePage = () => {
    const { id } = useParams();
    const [lead, setLead] = useState(null);
    const [phone, setPhone] = useState('');
    const [loading, setLoading] = useState(true);
    const [updating, setUpdating] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchLead = async () => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/leads/${id}`);
                setLead(res.data);
                setPhone(res.data.phone);
            } catch {
                setError('Could not fetch lead info.');
            } finally {
                setLoading(false);
            }
        };
        fetchLead();
    }, [id]);

    const handleSubmit = async () => {
        setUpdating(true);
        setSuccess(false);
        setError(null);
        try {
            await axios.patch(`${process.env.REACT_APP_BACKEND_URL}/api/leads/update-phone`, {
                id,
                phone,
            });
            setSuccess(true);
        } catch {
            setError('Failed to update phone number.');
        } finally {
            setUpdating(false);
        }
    };

    if (loading) {
        return (
            <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#000' }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box sx={{ minHeight: '100vh', bgcolor: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Container maxWidth="xs" sx={{ textAlign: 'center' }}>
                <Box sx={{ p: 4, borderRadius: 3, bgcolor: '#121212' }}>
                    <Typography variant="h6" fontWeight={600} color="#fff" mb={1.5}>
                        Update Phone
                    </Typography>
                    {lead && (
                        <>
                            <Typography variant="body2" color="#aaa" mb={3}>
                                Hi {lead.name}, please confirm or update your number.
                            </Typography>
                            <TextField
                                variant="filled"
                                fullWidth
                                label="Phone"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                sx={{
                                    mb: 2,
                                    input: { color: '#fff' },
                                    label: { color: '#888' },
                                    backgroundColor: '#1e1e1e',
                                    borderRadius: 1,
                                }}
                            />
                            <Button
                                fullWidth
                                onClick={handleSubmit}
                                disabled={updating}
                                sx={{
                                    bgcolor: brandGreen,
                                    color: '#000',
                                    fontWeight: 600,
                                    py: 1.2,
                                    borderRadius: 2,
                                    textTransform: 'none',
                                    '&:hover': { bgcolor: '#0fb58a' }
                                }}
                            >
                                {updating ? 'Updating…' : 'Update'}
                            </Button>
                            {success && (
                                <Typography mt={2} color="#0f0" fontSize="0.9rem">
                                    ✅ Updated successfully.
                                </Typography>
                            )}
                            {error && (
                                <Typography mt={2} color="#f55" fontSize="0.9rem">
                                    {error}
                                </Typography>
                            )}
                        </>
                    )}
                </Box>
            </Container>
        </Box>
    );
};

export default UpdatePhonePage;
